package com.example.mystybag.appCore.model.pages

import kotlinx.datetime.LocalDate

data class StatementRowDisplay(
    val id: Long,
    val bagName: String,
    val saleDateDisplay: String,
    val amountFormatted: String,
)

data class StatementsUIState(
    val isLoading: Boolean = true,
    val rows: List<StatementRowDisplay> = emptyList(),
    val totalAmountFormatted: String = "0.00",
    val reportPeriodDisplay: String = "—",
    val filterDateFrom: LocalDate? = null,
    val filterDateTo: LocalDate? = null,
)
